import { render, staticRenderFns } from "./LinksValueChange.vue?vue&type=template&id=0e8fbc84&"
import script from "./LinksValueChange.vue?vue&type=script&lang=js&"
export * from "./LinksValueChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports